export default __webpack_public_path__ + "static/media/empty-space@2x.e38a5894.png";